"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAvailableOrderingHours = void 0;

var _react = require("react");

var _find2 = _interopRequireDefault(require("lodash/find"));

var _map2 = _interopRequireDefault(require("lodash/map"));

var _toString2 = _interopRequireDefault(require("lodash/toString"));

var _moment = _interopRequireDefault(require("moment"));

var _types = require("@lce/types");

var _reactI18next = require("react-i18next");

var _hooks = require("../../settings/hooks");

var _store = require("../store");

var _types2 = require("../types");

var _useStoreOrderingHours = require("./useStoreOrderingHours");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // eslint-disable-next-line max-lines-per-function


var useAvailableOrderingHours = function useAvailableOrderingHours(locationNumber, orderType) {
  var _a, _b, _c, _d, _e, _f, _g, _h;

  var _j = (0, _reactI18next.useTranslation)(),
      t = _j.t,
      language = _j.i18n.language;

  var _k = (0, _hooks.useSettings)(),
      settings = _k.data,
      isLoadingSettings = _k.isLoading;

  var _l = (0, _store.useStoreDetailsByLocation)(locationNumber),
      storeDetails = _l.data,
      isLoadingStoreDetails = _l.isLoading;

  var _m = (0, _useStoreOrderingHours.useStoreOrderingHours)(),
      fetchStoreOrderingHours = _m.mutate,
      storeOrderingHoursData = _m.data,
      isLoadingOrderingHours = _m.isLoading;

  var _o = (0, _react.useState)(),
      selectedDay = _o[0],
      setSelectedDay = _o[1];

  var dateFormat = (0, _react.useMemo)(function () {
    return {
      today: t('DaysOfTheWeek.Today'),
      dateOrder: language === _types.Const.locales.mx.es ? 'D/M' : 'M/D'
    };
  }, [language]);
  var storeOrderingHours = storeOrderingHoursData === null || storeOrderingHoursData === void 0 ? void 0 : storeOrderingHoursData.storeOrderingHours;
  var defaultPrepTime = ((_a = settings === null || settings === void 0 ? void 0 : settings.CONFIG) === null || _a === void 0 ? void 0 : _a.DEFAULT_PREP_TIME) || 14;
  var futureOrderFeature = (_b = settings === null || settings === void 0 ? void 0 : settings.FEATURE) === null || _b === void 0 ? void 0 : _b.FUTURE_ORDER;
  var orderNowFeature = (_c = settings === null || settings === void 0 ? void 0 : settings.FEATURE) === null || _c === void 0 ? void 0 : _c.ORDER_NOW;
  var onlineOrderingFeature = (_d = settings === null || settings === void 0 ? void 0 : settings.FEATURE) === null || _d === void 0 ? void 0 : _d.ONLINE_ORDERING;
  var disabledDays = ((_e = settings === null || settings === void 0 ? void 0 : settings.FEATURE) === null || _e === void 0 ? void 0 : _e.DISABLED_FUTURE_ORDERING_DAYS) && ((_g = (_f = settings === null || settings === void 0 ? void 0 : settings.CONFIG) === null || _f === void 0 ? void 0 : _f.DISABLED_FUTURE_ORDERING_DAYS) === null || _g === void 0 ? void 0 : _g.DISABLE_DAYS);
  var futureDeliveryFeature = (_h = settings === null || settings === void 0 ? void 0 : settings.FEATURE) === null || _h === void 0 ? void 0 : _h.DELIVERY_FUTURE_ORDER;
  var futureOrderDeliveryDisabled = orderType === _types.Const.DELIVERY && !futureDeliveryFeature;
  var orderingStatus = (0, _react.useMemo)(function () {
    var _a, _b;

    return {
      AllOrderingAvailable: ((_a = storeDetails === null || storeDetails === void 0 ? void 0 : storeDetails.store) === null || _a === void 0 ? void 0 : _a.onlineOrderingStatus) === (_types2.OnlineOrderingStatus === null || _types2.OnlineOrderingStatus === void 0 ? void 0 : _types2.OnlineOrderingStatus.enabled),
      FutureOrderingAvailable: ((_b = storeDetails === null || storeDetails === void 0 ? void 0 : storeDetails.store) === null || _b === void 0 ? void 0 : _b.onlineOrderingStatus) === (_types2.OnlineOrderingStatus === null || _types2.OnlineOrderingStatus === void 0 ? void 0 : _types2.OnlineOrderingStatus.enabledStoreClosed) && !futureOrderDeliveryDisabled
    };
  }, [storeDetails, futureOrderDeliveryDisabled]);
  var isOrderingUnavailable = !orderingStatus.AllOrderingAvailable && !orderingStatus.FutureOrderingAvailable;
  var isOrderingDisabled = !onlineOrderingFeature || !orderNowFeature && !futureOrderFeature;
  (0, _react.useEffect)(function () {
    if (!isLoadingSettings && settings) {
      fetchStoreOrderingHours({
        type: orderType,
        locationNumber: locationNumber,
        prepTimeInMinutes: defaultPrepTime
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isLoadingSettings, settings]);
  var days = (0, _react.useMemo)(function () {
    var defaultLabel = "[" + dateFormat.today + "] " + dateFormat.dateOrder;

    if ((storeOrderingHours === null || storeOrderingHours === void 0 ? void 0 : storeOrderingHours.length) && futureOrderFeature && !isOrderingDisabled && !isOrderingUnavailable && !futureOrderDeliveryDisabled) {
      return (0, _map2["default"])(storeOrderingHours, function (item) {
        var label = (0, _moment["default"])().isSame(item.day, 'day') ? (0, _moment["default"])(item.day).format(defaultLabel) : t('DaysOfTheWeek.' + (0, _toString2["default"])((0, _moment["default"])(item.day).format('dddd'))) + " " + (0, _moment["default"])(item.day).format(dateFormat.dateOrder);
        return {
          value: item.day,
          label: label
        };
      });
    }

    return [{
      value: 'ASAP',
      label: (0, _moment["default"])().format(defaultLabel)
    }]; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateFormat, futureOrderDeliveryDisabled, futureOrderFeature, isOrderingDisabled, isOrderingUnavailable, storeOrderingHours]);
  var times = (0, _react.useMemo)(function () {
    var _a, _b;

    var predefinedTimeOptions = {
      asap: {
        value: 'ASAP',
        label: 'ASAP'
      },
      unavailable: {
        value: 'DISABLED',
        label: t('Common.OrderingUnavailable')
      }
    };
    var orderingTimes = [];
    var allOrderingAvailable = orderingStatus === null || orderingStatus === void 0 ? void 0 : orderingStatus.AllOrderingAvailable;
    var canPlaceFutureOrder = allOrderingAvailable || (orderingStatus === null || orderingStatus === void 0 ? void 0 : orderingStatus.FutureOrderingAvailable);

    if ((storeOrderingHours === null || storeOrderingHours === void 0 ? void 0 : storeOrderingHours.length) && futureOrderFeature && canPlaceFutureOrder) {
      var formattedSelectedDay_1 = (0, _moment["default"])(selectedDay).format('Y-MM-DD');
      var defaultTimes = formattedSelectedDay_1 ? (0, _find2["default"])(storeOrderingHours, function (obj) {
        return obj.day.includes(formattedSelectedDay_1);
      }) : storeOrderingHours[0];
      orderingTimes = (0, _map2["default"])(defaultTimes === null || defaultTimes === void 0 ? void 0 : defaultTimes.hours, function (time) {
        var label = (0, _moment["default"])(time).format('h:mm A');
        return {
          value: time,
          label: label
        };
      });
    }

    var isAsapAllowed = ((_a = orderingTimes === null || orderingTimes === void 0 ? void 0 : orderingTimes[0]) === null || _a === void 0 ? void 0 : _a.value) === ((_b = days === null || days === void 0 ? void 0 : days[0]) === null || _b === void 0 ? void 0 : _b.value) || !orderingTimes.length;

    if (isAsapAllowed && allOrderingAvailable && orderNowFeature) {
      orderingTimes.unshift(predefinedTimeOptions.asap);
    }

    if (futureOrderDeliveryDisabled) {
      orderingTimes = [predefinedTimeOptions.asap];
    }

    if (!storeOrderingHours && !allOrderingAvailable || isOrderingUnavailable || isOrderingDisabled) {
      orderingTimes = [predefinedTimeOptions.unavailable];
    }

    var selectedMonthDay = (0, _moment["default"])(selectedDay).format('MM/DD');
    var isToday = (0, _moment["default"])().isSame(selectedDay, 'day');
    var isDisabledDay = disabledDays && disabledDays.includes(selectedMonthDay);

    if (isDisabledDay) {
      orderingTimes = [isToday ? orderingTimes[0] : predefinedTimeOptions.unavailable];
    }

    if ((orderingTimes === null || orderingTimes === void 0 ? void 0 : orderingTimes.length) === 0) {
      orderingTimes = [predefinedTimeOptions.unavailable];
    }

    return orderingTimes;
  }, [days, disabledDays, futureOrderDeliveryDisabled, futureOrderFeature, isOrderingDisabled, isOrderingUnavailable, orderingStatus, orderNowFeature, selectedDay, storeOrderingHours]);
  var isLoading = isLoadingOrderingHours || isLoadingSettings || isLoadingStoreDetails;
  return {
    days: days,
    times: times,
    isLoading: isLoading,
    setSelectedDay: setSelectedDay
  };
};

exports.useAvailableOrderingHours = useAvailableOrderingHours;